import { InfiniteTable, TabContentWrapper } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { Button, Tooltip } from 'antd';
import { ColumnType } from 'antd/es/table/interface';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import EmailHistoryModal from './EmailHistoryModal';
import { useMailsHistory } from '@/core/domain/mail/MailHistory/MailHistory.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import moment from 'moment';
import {
  MailHistoryInterface,
  MailTypeEnum,
  mailType,
} from '@/core/domain/mail/MailHistory/MailHistory.types';
import EmailHistoryFilter from './EmailHistoryFilter';
import { useDebounce } from 'use-debounce';

export default function EmailHistoryPage({ route }: PageProps) {
  const [queryParams, setQueryParams] = useState({});
  const intl = useIntl().formatMessage;
  const [content, setContent] = useState<MailHistoryInterface>();

  const [filterDebounce] = useDebounce(queryParams, 500);
  const { data, hasNextPage, fetchNextPage, isLoading, isFetching } =
    useMailsHistory(filterDebounce);

  const mails = flatInfiniteData(data);

  const handleViewContent = (id: string) => {
    setContent(mails.find((mail) => mail.id === id));
  };

  const columns: ColumnType<MailHistoryInterface>[] = [
    {
      title: 'Tipo',
      dataIndex: 'mailType',
      key: 'mailType',
      render: (value: MailTypeEnum) => mailType[value] || 'Outros',
    },
    {
      title: 'Destinatário',
      dataIndex: 'to',
      key: 'to',
      render: (value, row) => (
        <Button type="link" onClick={() => handleViewContent(row.id)}>
          {value}
        </Button>
      ),
    },
    {
      title: 'Usuário enviou',
      dataIndex: 'fromName',
      key: 'fromName',
      render: (value, record) => <Tooltip title={record.from}>{value}</Tooltip>,
    },
    {
      title: 'Assunto',
      dataIndex: 'subject',
      key: 'subject',
    },
    {
      title: 'Status',
      dataIndex: 'failedMessage',
      key: 'failedMessage',
      render: (value) => value ?? 'Enviado',
    },
    {
      title: 'Data',
      dataIndex: 'sentDate',
      key: 'sentDate',
      render: (date) => moment(date).format('DD/MM/YYYY'),
    },
  ];

  return (
    <>
      <Helmet title={intl({ id: route.name })} />

      <TabContentWrapper title={route.name}>
        <EmailHistoryFilter
          queryParams={queryParams}
          setQueryParams={setQueryParams}
        />

        <InfiniteTable
          columns={columns}
          dataSource={mails}
          loading={isLoading}
          rowKey={(row) => row.id}
          hasNextPage={hasNextPage}
          fetchNextPage={fetchNextPage}
          isFetching={isFetching}
        />
      </TabContentWrapper>

      <EmailHistoryModal
        content={content}
        onCancel={() => setContent(undefined)}
      />
    </>
  );
}
